import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = {
    class: "cms-editor-container",
    style: { "height": "100vh" }
};
const _hoisted_2 = {
    key: 0,
    class: "text-center py-5 h-100 d-flex flex-column align-items-center justify-content-center bg-white",
    style: { "position": "absolute", "inset": "0", "z-index": "1000" }
};
const _hoisted_3 = {
    key: 1,
    class: "row g-0",
    style: { "height": "100%", "overflow": "hidden", "margin": "0", "padding": "0" }
};
const _hoisted_4 = {
    class: "col-xl-5 col-lg-6 border-end bg-light d-flex flex-column p-0",
    style: { "height": "100%" }
};
const _hoisted_5 = { class: "p-3 bg-white border-bottom d-flex justify-content-between align-items-center" };
const _hoisted_6 = { class: "d-flex align-items-center" };
const _hoisted_7 = { class: "mb-0 fw-bold" };
const _hoisted_8 = { class: "text-primary" };
const _hoisted_9 = ["disabled"];
const _hoisted_10 = {
    class: "flex-grow-1 p-4",
    style: { "overflow-y": "auto" }
};
const _hoisted_11 = { class: "mb-4 p-3 bg-white border rounded shadow-sm" };
const _hoisted_12 = { class: "row g-2 align-items-end" };
const _hoisted_13 = { class: "col-8" };
const _hoisted_14 = { class: "input-group input-group-sm" };
const _hoisted_15 = { class: "input-group-text" };
const _hoisted_16 = { class: "col-4" };
const _hoisted_17 = { class: "form-check form-switch custom-switch-v1 mb-1" };
const _hoisted_18 = { class: "d-flex justify-content-between align-items-center mb-1" };
const _hoisted_19 = {
    class: "nav nav-tabs border-0",
    role: "tablist"
};
const _hoisted_20 = ["onClick"];
const _hoisted_21 = { class: "editor-section mt-3" };
const _hoisted_22 = { class: "mb-3" };
const _hoisted_23 = { class: "mb-2 d-flex justify-content-between align-items-center" };
const _hoisted_24 = { class: "dropdown" };
const _hoisted_25 = {
    class: "dropdown-menu dropdown-menu-end shadow-lg border-0 p-2",
    style: { "width": "280px" }
};
const _hoisted_26 = {
    key: 0,
    class: "editor-wrapper shadow-sm border-0 rounded-3 bg-white",
    style: { "overflow": "hidden" }
};
const _hoisted_27 = {
    ref: "editorNode",
    style: { "min-height": "500px", "font-size": "16px" }
};
const _hoisted_28 = {
    key: 1,
    class: "structured-editor"
};
const _hoisted_29 = { class: "card-header bg-white py-3" };
const _hoisted_30 = { class: "mb-0 fw-bold text-primary" };
const _hoisted_31 = { class: "card-body" };
const _hoisted_32 = { class: "mb-3" };
const _hoisted_33 = ["onUpdate:modelValue"];
const _hoisted_34 = { class: "mb-3" };
const _hoisted_35 = ["onUpdate:modelValue"];
const _hoisted_36 = { class: "mb-0" };
const _hoisted_37 = { class: "d-flex align-items-center gap-3 mt-1" };
const _hoisted_38 = {
    class: "rounded-3 border border-2 border-dashed d-flex align-items-center justify-content-center overflow-hidden bg-light",
    style: { "width": "120px", "height": "80px" }
};
const _hoisted_39 = ["src"];
const _hoisted_40 = {
    key: 1,
    class: "ri-image-add-line fs-4 text-muted"
};
const _hoisted_41 = ["onClick"];
const _hoisted_42 = {
    key: 2,
    class: "mt-4 p-3 bg-white rounded border border-dashed text-center"
};
const _hoisted_43 = {
    key: 3,
    class: "mt-4 p-3 bg-dark rounded border"
};
const _hoisted_44 = { class: "d-flex justify-content-between align-items-center mb-2" };
const _hoisted_45 = {
    class: "col-xl-7 col-lg-6 bg-secondary d-flex flex-column",
    style: { "height": "100%" }
};
const _hoisted_46 = {
    class: "p-2 bg-white border-bottom d-flex justify-content-between align-items-center px-4",
    style: { "height": "57px" }
};
const _hoisted_47 = { class: "d-flex align-items-center" };
const _hoisted_48 = {
    key: 0,
    class: "spinner-grow spinner-grow-sm text-success me-2",
    role: "status"
};
const _hoisted_49 = {
    key: 1,
    class: "ri-eye-line text-success me-2"
};
const _hoisted_50 = { class: "d-flex gap-2" };
const _hoisted_51 = { class: "btn-group btn-group-sm border rounded-pill overflow-hidden" };
const _hoisted_52 = ["href"];
const _hoisted_53 = {
    class: "flex-grow-1 bg-light p-4 d-flex justify-content-center",
    style: { "overflow-y": "auto" }
};
const _hoisted_54 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[18] || (_cache[18] = [
                    _createElementVNode("div", {
                        class: "spinner-border text-primary",
                        role: "status"
                    }, null, -1),
                    _createElementVNode("p", { class: "mt-2 text-muted fw-bold" }, "Préparation de l'aperçu en direct...", -1)
                ]))]))
            : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("div", _hoisted_6, [
                            _createElementVNode("button", {
                                class: "btn btn-outline-secondary btn-sm me-3",
                                onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$router.push('/marketing/pages')))
                            }, [...(_cache[19] || (_cache[19] = [
                                    _createElementVNode("i", { class: "ri-arrow-left-line" }, null, -1)
                                ]))]),
                            _createElementVNode("h5", _hoisted_7, [
                                _cache[20] || (_cache[20] = _createTextVNode("Éditeur ", -1)),
                                _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.currentTitle), 1)
                            ])
                        ]),
                        _createElementVNode("button", {
                            class: "btn btn-primary btn-sm px-4 shadow-sm",
                            onClick: _cache[1] || (_cache[1] =
                                //@ts-ignore
                                (...args) => (_ctx.savePage && _ctx.savePage(...args))),
                            disabled: _ctx.saving
                        }, [
                            _cache[21] || (_cache[21] = _createElementVNode("i", { class: "ri-save-line me-1" }, null, -1)),
                            _createTextVNode(" " + _toDisplayString(_ctx.saving ? 'Sauvegarde...' : 'Publier'), 1)
                        ], 8, _hoisted_9)
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("div", _hoisted_12, [
                                _createElementVNode("div", _hoisted_13, [
                                    _cache[22] || (_cache[22] = _createElementVNode("label", { class: "form-label small fw-bold text-uppercase text-muted" }, "URL de la page", -1)),
                                    _createElementVNode("div", _hoisted_14, [
                                        _createElementVNode("span", _hoisted_15, "/" + _toDisplayString(_ctx.activeLocale) + "/", 1),
                                        _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            class: "form-control",
                                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.form.slug) = $event)),
                                            placeholder: "slug"
                                        }, null, 512), [
                                            [_vModelText, _ctx.form.slug]
                                        ])
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_16, [
                                    _createElementVNode("div", _hoisted_17, [
                                        _withDirectives(_createElementVNode("input", {
                                            class: "form-check-input",
                                            type: "checkbox",
                                            id: "pageStatus",
                                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.form.isActive) = $event))
                                        }, null, 512), [
                                            [_vModelCheckbox, _ctx.form.isActive]
                                        ]),
                                        _cache[23] || (_cache[23] = _createElementVNode("label", {
                                            class: "form-check-label small",
                                            for: "pageStatus"
                                        }, "En ligne", -1))
                                    ])
                                ])
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_18, [
                            _createElementVNode("ul", _hoisted_19, [
                                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['fr', 'en', 'de', 'it'], (lang) => {
                                    return _createElementVNode("li", {
                                        class: "nav-item",
                                        key: lang
                                    }, [
                                        _createElementVNode("a", {
                                            class: _normalizeClass(["nav-link px-3 py-2 border-0", { active: _ctx.activeLocale === lang, 'text-primary border-bottom-2': _ctx.activeLocale === lang }]),
                                            onClick: _withModifiers(($event) => (_ctx.activeLocale = lang), ["prevent"]),
                                            href: "#",
                                            style: { "font-size": "13px", "font-weight": "700" }
                                        }, _toDisplayString(lang.toUpperCase()), 11, _hoisted_20)
                                    ]);
                                }), 64))
                            ]),
                            _createElementVNode("button", {
                                class: "btn btn-light btn-sm",
                                onClick: _cache[4] || (_cache[4] =
                                    //@ts-ignore
                                    (...args) => (_ctx.syncImagesAcrossLocales && _ctx.syncImagesAcrossLocales(...args))),
                                title: "Sync images"
                            }, [...(_cache[24] || (_cache[24] = [
                                    _createElementVNode("i", { class: "ri-refresh-line" }, null, -1),
                                    _createTextVNode(" Sync images ", -1)
                                ]))])
                        ]),
                        _createElementVNode("div", _hoisted_21, [
                            _createElementVNode("div", _hoisted_22, [
                                _cache[25] || (_cache[25] = _createElementVNode("label", { class: "form-label small fw-bold text-uppercase text-muted" }, "Titre de la page", -1)),
                                _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    class: "form-control form-control-lg border-0 shadow-sm",
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_ctx.translations[_ctx.activeLocale].title) = $event)),
                                    style: { "font-weight": "700" }
                                }, null, 512), [
                                    [_vModelText, _ctx.translations[_ctx.activeLocale].title]
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_23, [
                                _cache[33] || (_cache[33] = _createElementVNode("label", { class: "form-label small fw-bold text-uppercase text-muted mb-0" }, "Sections de la page", -1)),
                                _createElementVNode("div", _hoisted_24, [
                                    _cache[32] || (_cache[32] = _createElementVNode("button", {
                                        class: "btn btn-primary btn-sm rounded-pill px-3",
                                        "data-bs-toggle": "dropdown"
                                    }, [
                                        _createElementVNode("i", { class: "ri-add-line" }),
                                        _createTextVNode(" Ajouter un bloc ")
                                    ], -1)),
                                    _createElementVNode("ul", _hoisted_25, [
                                        _cache[31] || (_cache[31] = _createElementVNode("li", { class: "p-2 small fw-bold text-muted border-bottom mb-2 text-uppercase" }, "Bibliothèque de Blocs", -1)),
                                        _createElementVNode("li", null, [
                                            _createElementVNode("a", {
                                                class: "dropdown-item rounded py-2 d-flex align-items-center",
                                                href: "#",
                                                onClick: _cache[6] || (_cache[6] = _withModifiers(($event) => (_ctx.insertBlockTemplate('HERO_CARD')), ["prevent"]))
                                            }, [...(_cache[26] || (_cache[26] = [
                                                    _createElementVNode("div", { class: "p-2 bg-success-subtle rounded me-3 text-success" }, [
                                                        _createElementVNode("i", { class: "ri-layout-top-line" })
                                                    ], -1),
                                                    _createElementVNode("div", null, [
                                                        _createElementVNode("div", { class: "fw-bold" }, "Bannière Titre"),
                                                        _createElementVNode("div", { class: "smaller text-muted" }, "Box light green")
                                                    ], -1)
                                                ]))])
                                        ]),
                                        _createElementVNode("li", null, [
                                            _createElementVNode("a", {
                                                class: "dropdown-item rounded py-2 d-flex align-items-center",
                                                href: "#",
                                                onClick: _cache[7] || (_cache[7] = _withModifiers(($event) => (_ctx.insertBlockTemplate('IMAGE_TEXT_LEFT')), ["prevent"]))
                                            }, [...(_cache[27] || (_cache[27] = [
                                                    _createElementVNode("div", { class: "p-2 bg-primary-subtle rounded me-3 text-primary" }, [
                                                        _createElementVNode("i", { class: "ri-image-line" })
                                                    ], -1),
                                                    _createElementVNode("div", null, [
                                                        _createElementVNode("div", { class: "fw-bold" }, "Image à Gauche"),
                                                        _createElementVNode("div", { class: "smaller text-muted" }, "Texte à droite")
                                                    ], -1)
                                                ]))])
                                        ]),
                                        _createElementVNode("li", null, [
                                            _createElementVNode("a", {
                                                class: "dropdown-item rounded py-2 d-flex align-items-center",
                                                href: "#",
                                                onClick: _cache[8] || (_cache[8] = _withModifiers(($event) => (_ctx.insertBlockTemplate('IMAGE_TEXT_RIGHT')), ["prevent"]))
                                            }, [...(_cache[28] || (_cache[28] = [
                                                    _createElementVNode("div", { class: "p-2 bg-info-subtle rounded me-3 text-info" }, [
                                                        _createElementVNode("i", { class: "ri-image-line" })
                                                    ], -1),
                                                    _createElementVNode("div", null, [
                                                        _createElementVNode("div", { class: "fw-bold" }, "Image à Droite"),
                                                        _createElementVNode("div", { class: "smaller text-muted" }, "Texte à gauche")
                                                    ], -1)
                                                ]))])
                                        ]),
                                        _createElementVNode("li", null, [
                                            _createElementVNode("a", {
                                                class: "dropdown-item rounded py-2 d-flex align-items-center",
                                                href: "#",
                                                onClick: _cache[9] || (_cache[9] = _withModifiers(($event) => (_ctx.insertBlockTemplate('APP_PROMO')), ["prevent"]))
                                            }, [...(_cache[29] || (_cache[29] = [
                                                    _createElementVNode("div", { class: "p-2 bg-danger-subtle rounded me-3 text-danger" }, [
                                                        _createElementVNode("i", { class: "ri-smartphone-line" })
                                                    ], -1),
                                                    _createElementVNode("div", null, [
                                                        _createElementVNode("div", { class: "fw-bold" }, "Promo App"),
                                                        _createElementVNode("div", { class: "smaller text-muted" }, "Boutons Store")
                                                    ], -1)
                                                ]))])
                                        ]),
                                        _createElementVNode("li", null, [
                                            _createElementVNode("a", {
                                                class: "dropdown-item rounded py-2 d-flex align-items-center",
                                                href: "#",
                                                onClick: _cache[10] || (_cache[10] = _withModifiers(($event) => (_ctx.insertBlockTemplate('GALLERY')), ["prevent"]))
                                            }, [...(_cache[30] || (_cache[30] = [
                                                    _createElementVNode("div", { class: "p-2 bg-warning-subtle rounded me-3 text-warning" }, [
                                                        _createElementVNode("i", { class: "ri-gallery-line" })
                                                    ], -1),
                                                    _createElementVNode("div", null, [
                                                        _createElementVNode("div", { class: "fw-bold" }, "Grille d'images"),
                                                        _createElementVNode("div", { class: "smaller text-muted" }, "Mosaïque photo")
                                                    ], -1)
                                                ]))])
                                        ])
                                    ])
                                ])
                            ]),
                            (!_ctx.isStructuredPage)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                    _createElementVNode("div", _hoisted_27, null, 512)
                                ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.aboutSections, (section, key) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                            key: key,
                                            class: "card border-0 shadow-sm mb-4"
                                        }, [
                                            _createElementVNode("div", _hoisted_29, [
                                                _createElementVNode("h6", _hoisted_30, [
                                                    _cache[34] || (_cache[34] = _createElementVNode("i", { class: "ri-layout-masonry-line me-2" }, null, -1)),
                                                    _createTextVNode(_toDisplayString(section.label), 1)
                                                ])
                                            ]),
                                            _createElementVNode("div", _hoisted_31, [
                                                _createElementVNode("div", _hoisted_32, [
                                                    _cache[35] || (_cache[35] = _createElementVNode("label", { class: "form-label small fw-bold text-uppercase text-muted" }, "Titre de la section", -1)),
                                                    _withDirectives(_createElementVNode("input", {
                                                        type: "text",
                                                        class: "form-control",
                                                        "onUpdate:modelValue": ($event) => ((_ctx.sectionData.sections[key].title) = $event),
                                                        placeholder: "Laissez vide pour garder le texte par défaut"
                                                    }, null, 8, _hoisted_33), [
                                                        [_vModelText, _ctx.sectionData.sections[key].title]
                                                    ])
                                                ]),
                                                _createElementVNode("div", _hoisted_34, [
                                                    _cache[36] || (_cache[36] = _createElementVNode("label", { class: "form-label small fw-bold text-uppercase text-muted" }, "Description", -1)),
                                                    _withDirectives(_createElementVNode("textarea", {
                                                        class: "form-control",
                                                        rows: "4",
                                                        "onUpdate:modelValue": ($event) => ((_ctx.sectionData.sections[key].description) = $event),
                                                        placeholder: "Laissez vide pour garder le texte par défaut"
                                                    }, null, 8, _hoisted_35), [
                                                        [_vModelText, _ctx.sectionData.sections[key].description]
                                                    ])
                                                ]),
                                                _createElementVNode("div", _hoisted_36, [
                                                    _cache[38] || (_cache[38] = _createElementVNode("label", { class: "form-label small fw-bold text-uppercase text-muted" }, "Image", -1)),
                                                    _createElementVNode("div", _hoisted_37, [
                                                        _createElementVNode("div", _hoisted_38, [
                                                            (_ctx.sectionData.sections[key].image)
                                                                ? (_openBlock(), _createElementBlock("img", {
                                                                    key: 0,
                                                                    src: _ctx.sectionData.sections[key].image,
                                                                    class: "w-100 h-100 object-cover"
                                                                }, null, 8, _hoisted_39))
                                                                : (_openBlock(), _createElementBlock("i", _hoisted_40))
                                                        ]),
                                                        _createElementVNode("button", {
                                                            class: "btn btn-outline-primary btn-sm rounded-pill px-3",
                                                            onClick: ($event) => (_ctx.pickSectionImage(key))
                                                        }, [...(_cache[37] || (_cache[37] = [
                                                                _createElementVNode("i", { class: "ri-upload-cloud-line me-1" }, null, -1),
                                                                _createTextVNode(" Changer l'image ", -1)
                                                            ]))], 8, _hoisted_41)
                                                    ])
                                                ])
                                            ])
                                        ]));
                                    }), 128))
                                ])),
                            (!_ctx.showRawHtml)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                                    _createElementVNode("button", {
                                        class: "btn btn-link btn-sm text-muted text-decoration-none",
                                        onClick: _cache[11] || (_cache[11] = ($event) => (_ctx.showRawHtml = true))
                                    }, [...(_cache[39] || (_cache[39] = [
                                            _createElementVNode("i", { class: "ri-code-s-slash-line me-1" }, null, -1),
                                            _createTextVNode(" Mode Expert (HTML)", -1)
                                        ]))])
                                ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_43, [
                                    _createElementVNode("div", _hoisted_44, [
                                        _cache[40] || (_cache[40] = _createElementVNode("span", { class: "fw-bold small text-white-50" }, "CODE SOURCE HTML", -1)),
                                        _createElementVNode("div", null, [
                                            _createElementVNode("button", {
                                                class: "btn btn-link btn-sm text-white-50 p-0 me-3",
                                                onClick: _cache[12] || (_cache[12] = ($event) => (_ctx.showRawHtml = false))
                                            }, "Fermer"),
                                            _createElementVNode("button", {
                                                class: "btn btn-outline-light btn-sm",
                                                onClick: _cache[13] || (_cache[13] = ($event) => (_ctx.syncFromRaw(_ctx.activeLocale)))
                                            }, "Appliquer")
                                        ])
                                    ]),
                                    _withDirectives(_createElementVNode("textarea", {
                                        class: "form-control form-control-sm font-monospace text-white bg-dark border-secondary",
                                        style: { "height": "250px", "font-size": "11px" },
                                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event) => ((_ctx.translations[_ctx.activeLocale].content) = $event))
                                    }, null, 512), [
                                        [_vModelText, _ctx.translations[_ctx.activeLocale].content]
                                    ])
                                ]))
                        ])
                    ])
                ]),
                _createElementVNode("div", _hoisted_45, [
                    _createElementVNode("div", _hoisted_46, [
                        _createElementVNode("div", _hoisted_47, [
                            (_ctx.syncingPreview)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_48))
                                : (_openBlock(), _createElementBlock("i", _hoisted_49)),
                            _cache[41] || (_cache[41] = _createElementVNode("span", { class: "small fw-bold text-muted uppercase" }, "Aperçu en direct", -1))
                        ]),
                        _createElementVNode("div", _hoisted_50, [
                            _createElementVNode("div", _hoisted_51, [
                                _createElementVNode("button", {
                                    class: _normalizeClass(["btn border-0 py-1", _ctx.previewSize === 'desktop' ? 'btn-primary' : 'btn-white']),
                                    onClick: _cache[15] || (_cache[15] = ($event) => (_ctx.previewSize = 'desktop'))
                                }, [...(_cache[42] || (_cache[42] = [
                                        _createElementVNode("i", { class: "ri-computer-line" }, null, -1)
                                    ]))], 2),
                                _createElementVNode("button", {
                                    class: _normalizeClass(["btn border-0 py-1", _ctx.previewSize === 'mobile' ? 'btn-primary' : 'btn-white']),
                                    onClick: _cache[16] || (_cache[16] = ($event) => (_ctx.previewSize = 'mobile'))
                                }, [...(_cache[43] || (_cache[43] = [
                                        _createElementVNode("i", { class: "ri-smartphone-line" }, null, -1)
                                    ]))], 2)
                            ]),
                            _createElementVNode("a", {
                                href: _ctx.previewUrl,
                                target: "_blank",
                                class: "btn btn-light btn-sm rounded-pill"
                            }, [...(_cache[44] || (_cache[44] = [
                                    _createElementVNode("i", { class: "ri-external-link-line" }, null, -1)
                                ]))], 8, _hoisted_52)
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_53, [
                        _createElementVNode("div", {
                            class: "preview-frame-wrapper shadow-2xl bg-white",
                            style: _normalizeStyle({ width: _ctx.previewSize === 'mobile' ? '375px' : '100%', height: 'calc(100%)', transition: 'width 0.4s cubic-bezier(0.4, 0, 0.2, 1)' })
                        }, [
                            _createElementVNode("iframe", {
                                ref: "previewIframe",
                                src: _ctx.previewUrl,
                                class: "w-100 h-100 border-0",
                                onLoad: _cache[17] || (_cache[17] =
                                    //@ts-ignore
                                    (...args) => (_ctx.onPreviewLoaded && _ctx.onPreviewLoaded(...args)))
                            }, null, 40, _hoisted_54)
                        ], 4)
                    ])
                ])
            ]))
    ]));
}
